// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-7df28e9e] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.notecard[data-v-7df28e9e] {
  --note-card-icon-size: 20px;
  --note-card-padding: calc(2 * var(--default-grid-baseline));
  color: var(--color-main-text) !important;
  background-color: var(--note-background) !important;
  border-inline-start: var(--default-grid-baseline) solid var(--note-theme);
  border-radius: var(--border-radius);
  margin: 1rem 0;
  padding: var(--note-card-padding);
  display: flex;
  flex-direction: row;
  gap: var(--note-card-padding);
}
.notecard__heading[data-v-7df28e9e] {
  font-size: var(--note-card-icon-size);
  font-weight: 600;
}
.notecard__icon--heading[data-v-7df28e9e] {
  font-size: var(--note-card-icon-size);
  margin-block: calc((1lh - 1em) / 2) auto;
}
.notecard--success[data-v-7df28e9e] {
  --note-background: rgba(var(--color-success-rgb), 0.1);
  --note-theme: var(--color-success);
}
.notecard--info[data-v-7df28e9e] {
  --note-background: rgba(var(--color-info-rgb), 0.1);
  --note-theme: var(--color-info);
}
.notecard--error[data-v-7df28e9e] {
  --note-background: rgba(var(--color-error-rgb), 0.1);
  --note-theme: var(--color-error);
}
.notecard--warning[data-v-7df28e9e] {
  --note-background: rgba(var(--color-warning-rgb), 0.1);
  --note-theme: var(--color-warning);
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcNoteCard-C6xb7vi0.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,2DAA2D;EAC3D,wCAAwC;EACxC,mDAAmD;EACnD,yEAAyE;EACzE,mCAAmC;EACnC,cAAc;EACd,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;AACA;EACE,sDAAsD;EACtD,kCAAkC;AACpC;AACA;EACE,mDAAmD;EACnD,+BAA+B;AACjC;AACA;EACE,oDAAoD;EACpD,gCAAgC;AAClC;AACA;EACE,sDAAsD;EACtD,kCAAkC;AACpC","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-7df28e9e] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.notecard[data-v-7df28e9e] {\n  --note-card-icon-size: 20px;\n  --note-card-padding: calc(2 * var(--default-grid-baseline));\n  color: var(--color-main-text) !important;\n  background-color: var(--note-background) !important;\n  border-inline-start: var(--default-grid-baseline) solid var(--note-theme);\n  border-radius: var(--border-radius);\n  margin: 1rem 0;\n  padding: var(--note-card-padding);\n  display: flex;\n  flex-direction: row;\n  gap: var(--note-card-padding);\n}\n.notecard__heading[data-v-7df28e9e] {\n  font-size: var(--note-card-icon-size);\n  font-weight: 600;\n}\n.notecard__icon--heading[data-v-7df28e9e] {\n  font-size: var(--note-card-icon-size);\n  margin-block: calc((1lh - 1em) / 2) auto;\n}\n.notecard--success[data-v-7df28e9e] {\n  --note-background: rgba(var(--color-success-rgb), 0.1);\n  --note-theme: var(--color-success);\n}\n.notecard--info[data-v-7df28e9e] {\n  --note-background: rgba(var(--color-info-rgb), 0.1);\n  --note-theme: var(--color-info);\n}\n.notecard--error[data-v-7df28e9e] {\n  --note-background: rgba(var(--color-error-rgb), 0.1);\n  --note-theme: var(--color-error);\n}\n.notecard--warning[data-v-7df28e9e] {\n  --note-background: rgba(var(--color-warning-rgb), 0.1);\n  --note-theme: var(--color-warning);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
